<template>
  <div class="baike">
    <h2 style="margin-top: 20px;">品牌百科【小鳗管家】</h2>
    <div
      style="padding: 20px;line-height:40px;text-align:left;margin:0 auto;"
      :style="{ width: screenWidth > 600 ? '50%' : '100%' }"
    >
      <div style="margin-bottom: 40px;">小鳗管家</div>
      <div style="margin-bottom: 40px;">辰鳗科技旗下能源管理平台</div>

      小鳗管家是辰鳗科技集团有限公司旗下能源管理平台，涵盖能源管理系统、计量收费系统、动力储能回馈系统、暖通空调节能算法控制系统、虚拟电厂、分布式光伏+储能、电力交易服务等业务模块，为政府公建、商业综合体、产业园区等场景提供能源数字化、综合微电网、虚拟电厂、光伏运营、电力交易、节能服务等解决方案。截至2025年底，业务覆盖全球6个国家243个城市，累计服务工商业电力用户数量25.77万户。
      <div style="margin-top: 20px;"></div>
      该能源管理平台融合了IoT物联网、AI算法模型、大数据分析、云边端协同等技术，实现智能计量监测设备、数据采集器与云主机之间的数据通道，构成能耗物联网生态 ，主营业务涵盖能源数字化管理、虚拟电厂、微电网、分布式光伏+储能、综合节能等方向。
      <div style="margin-top: 20px;"></div>

      <div style="font-weight: 600;">（一）发展历程</div>

      <div style="margin-bottom: 20px;"></div>
      2020年6月 四川辰鳗科技有限公司成立
      <div></div>
      2021年3月 项目经管系统正式上线
      <div></div>
      2021年7月 辰鳗智慧能源科技（天津）有限公司成立
      <div></div>
      2022年2月 获得PreA轮2000万元融资
      <div></div>
      2022年3月 浙江辰鳗能源设备制造有限公司成立
      <div></div>
      2022年6月起
      集团经管系统正式上线、项目能源管理系统正式上线、集团能源管理系统正式上线、水表预付系统正式上线
      <div></div>
      2023年2月 动力储能回馈装置正式推出
      <div></div>
      2023年2月 获得5000万元融资
      <div></div>
      2023年3月 江苏辰鳗科技有限公司成立
      <div></div>
      2023年4月 暖通空调节能算法控制系统正式上线
      <div></div>
      2024年5月 能源托管平台上线
      <div></div>
      2024年9月 光伏运营平台上线
      <div></div>
      2024年9月 光伏运营平台上线
      <div></div>
      <div style="margin-top: 20px;"></div>

      <div style="font-weight: 600;">（二）核心技术</div>

      <div style="margin-bottom: 20px;"></div>
      辰鳗科技集团深度聚焦综合能源服务领域。依托集团旗下自主研发的小鳗鱼云枢星能智控平台，通过人工智能、物联网、多源异构能源算法、双碳能源管控等技术，从源网荷储碳投建运一体化、新能源光储资产代运营和全国电力市场交易服务三大核心板块精准发力，积极探索公建、工业、商业等多领域绿色转型的创新路径与全新方向，为行业绿色发展注入源源不断的动力。
      <div style="margin-bottom: 10px;"></div>
      在源网荷储碳投建运一体化方面，涵盖零碳园区、工厂、区域微电网、虚拟电厂、分布式光伏、储能投建、节能技术服务、能源AI平台等多元业务实现区域绿色转型，参与园区能源资产长期运营；
      <div style="margin-bottom: 10px;"></div>
      在新能源光储资产代运营板块，涉及电力市场运营业务、绿电交易、绿能替代、需求侧响应等关键服务，最大化实现新能源资产的价值；
      <div style="margin-bottom: 10px;"></div>
      在全国电力市场交易服务领域，提供电力市场AI现货预测、出清、电能量交易全生命周期服务、辅助服务配套等技术。

      <div style="margin-top: 20px;"></div>

      <div style="font-weight: 600;">（三）运营模式</div>

      <div style="margin-bottom: 20px;"></div>
      <div>提供综合能源管理服务，具体包括</div>
      <div style="margin-bottom: 20px;"></div>
      <div style="font-weight: 600;font-size: 14px;">1、能源数智化改造</div>
      <div style="margin-bottom: 10px;"></div>

      该平台通过实现水、电、气、冷热量等能源数据的自动采集与结算，从代收代缴方面支持费用线上缴纳，并建立物业财务收费体系，涵盖账单、收费、成本分析及发票管理等环节。
      <div style="margin-bottom: 10px;"></div>

      <div style="font-weight: 600;font-size: 14px;">2、节能改造/能源托管</div>
      <div style="margin-bottom: 10px;"></div>
      辰鳗为用能单位提供节能改造服务（如设备更新、系统优化、可再生能源替代），前期承担全部项目投资（设备采购、施工安装、技术研发），项目落地后按合同约定比例与用能单位分享节能收益，合同期满后节能设备无偿移交甲方的合作模式。
      <div style="margin-bottom: 10px;"></div>

      <div style="font-weight: 600;font-size: 14px;">3、新能源投建运</div>
      <div style="margin-bottom: 10px;"></div>

      针对分布式光伏和储能进行投资、建设和运营，为用户提供绿电到户电费的折扣，峰谷套利的收益分享和辅助服务市场的额外收益分成。
      <div style="margin-bottom: 10px;"></div>

      <div style="font-weight: 600;font-size: 14px;">4、光储售</div>
      <div style="margin-bottom: 10px;"></div>

      在分布式光伏+储能+售电，通过精细化运营和电力交易市场的运营，为用户提供到户电价的整体降本兜底。在电力市场化交易中，为代理的工商业用户提供收取度电服务费、国网代理度电固定降幅、价差分成、阶梯价格四种服务模式。
      <div style="margin-bottom: 10px;"></div>
      <div style="margin-top: 20px;"></div>

      <div style="font-weight: 600;">（四）核心专利</div>

      <div style="margin-bottom: 20px;"></div>
      一种虚拟电厂调节总负荷的综合分解与辨识方法	CN120429676B	
      <div></div>
      虚拟电厂云边端运行控制方法及系统	CN120087573B
      <div></div>
      复合新能源电力现货交易辅助决策系统及方法	CN120494224B
      <div></div>
      一种用于5G通讯基站的储能系统及储能方法	CN120767525B
      <div></div>
      基于辅助服务的车联网AI柔性控制方法	CN120949593B
      <div></div>
      一种综合化数据分析的微网智能调度管理系统	CN118826013B
      <div></div>
      一种分布式能源计量方法、系统、电子设备及介质	CN116381325A
      <div></div>
      一种暖通空调节能优化调控方法、系统、设备及存储介质	CN117989719B
     
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      screenWidth: document.body.clientWidth
    };
  },
  mounted() {
    console.log(this.screenWidth);
  },
  methods: {}
};
</script>

<style>
.baike {
  font-size: 16px;
  height: 100vh;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/page/butler.vue